import { render } from "./EditService.vue?vue&type=template&id=65b0d02a&scoped=true"
import script from "./EditService.vue?vue&type=script&lang=js"
export * from "./EditService.vue?vue&type=script&lang=js"

import "./EditService.vue?vue&type=style&index=0&id=65b0d02a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65b0d02a"]])

export default __exports__